import React, { useEffect,useState,useCallback } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

//import * as LogisticUtility from '../../../Common/Utilties/LogisticUtility'

//import editIcon from '../../../../image/edit-icon2.png'; 

const MediaWrap = styled.div`
  width:1837px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px ${props => props.selected ? 'rgba(0,128,0,0.8)' : 'rgba(0,0,0,0.4)'};

  color: #000;
  font-size: 16px;

  text-align: center;
  align-items: center;
`

const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: 2px dashed #fff;
`

const TextWrap = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 

const ScreenButton = styled.button`
  display: flex;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.05em;
  text-align: center;
  vertical-align: middle;
  color: ${props => props.activeState ? '#fff' : '#000'};
  background-color: ${props => props.activeState ? '#649CDF' : '#ccc'};
  width: 80px;
  height: 30px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);
`
const MediaLastItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: row;
  height: 40px;
`

const MediaDataDaily = (props) => {
  const {
    grants,
    searchDate,
    data,
  } = props
  const [fileName, setFileName] = useState('');  

  //CSV取り込み
  const handleFileSelect=useCallback(async(e)=> {
    e.persist()
    if (!(e.target instanceof HTMLInputElement)) {
        return
    }
    if (!e.target.files){
        return
    }
    if (!e.target.files[0]){
        return
    }
    const fileName = await e.target.files[0].name;
    const file = await e.target.files[0]
    setFileName(fileName)
    data.file = file;
    console.log(fileName)
    data.fileName = fileName
    e.target = ''
    return
  },[data]);
  if (!data) return null;
  //console.log(data);
  return (
    <MediaWrap>
      <MediaItem>
        <TextWrap style={{width:'150px', textAlign:'left'}}>
          <div style={{marginLeft:'1rem'}}>{data.type?'中部':'イニシオ'}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'950px', textAlign:'center'}}>
          <input type="text" style={{width:'900px'}} value={fileName} disabled/>
        </TextWrap>
      </MediaItem>
      <MediaLastItem>
        <div style={{margin:'auto 0 auto 0.5rem' }}>
          <ScreenButton 
            name='参照' padding='0px' type="button"  
            onClick={()=>{
              const fileElem = document.getElementById("fileElem"+data.type);
              if (fileElem) {
                fileElem.click();
              }
            }} 
            activeState
          >
          <TextWrap style={{textAlign:'center'}}>
            <div>参照</div>
          </TextWrap>
          </ScreenButton>
          <input type="file" accept="text" onChange={handleFileSelect} style={{display:'none'}} id={"fileElem"+data.type}/>
        </div>
      </MediaLastItem>
    </MediaWrap>
  )
}

MediaDataDaily.propTypes = {
  grants: PropTypes.object, // 権限関連
  data: PropTypes.object, // VAS個人実績
}

export default MediaDataDaily
